module.exports = __webpack_public_path__ + "static/img/denglulogo.08e7aee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/denglulogo.png
// module id = yMvk
// module chunks = 1